(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class GicPendantChainPicker extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.addEventListener('change', () => this.update());
    this.addEventListener('animationend', (event) => { if (event.target === this) this.classList.remove('gic-chain--shake'); });
    this.update();
  }
  isSelectionComplete() {
    const checked = this.querySelector('input[type="radio"]:checked');
    return !!checked && !checked.disabled && (checked.value === 'none' || !!this.getSelection());
  }
  clearError() {
    this.classList.remove('gic-chain--invalid', 'gic-chain--shake');
    const error = this.querySelector('[data-chain-error]');
    if (error) error.hidden = true;
    this.querySelector('[data-chain-toggle]')?.removeAttribute('aria-invalid');
  }
  validateSelection() {
    if (this.isSelectionComplete()) { this.clearError(); return true; }
    const drawer = this.querySelector('[data-chain-drawer]');
    if (drawer) drawer.open = true;
    this.classList.add('gic-chain--invalid');
    const error = this.querySelector('[data-chain-error]');
    if (error) { error.textContent = this.dataset.errorMessage || 'Please select a chain option.'; error.hidden = false; }
    const toggle = this.querySelector('[data-chain-toggle]');
    toggle?.setAttribute('aria-invalid', 'true');
    this.classList.remove('gic-chain--shake');
    void this.offsetWidth;
    this.classList.add('gic-chain--shake');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.scrollIntoView({ block: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
    toggle?.focus({ preventScroll: true });
    return false;
  }
  money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
  }
  getSelection() {
    const checked = this.querySelector('input[type="radio"]:checked');
    if (!checked || checked.value === 'none' || checked.disabled) return null;
    const card = checked.closest('[data-slot]');
    const selected = card?.querySelector('select')?.selectedOptions[0];
    if (!selected || selected.dataset.available !== 'true') return null;
    const free = card.dataset.free === 'true';
    const discount = Number(card.dataset.discount) || 0;
    const price = Number(selected.dataset.price) || 0;
    const ready = free ? this.dataset.freeReady === 'true' : card.dataset.ready === 'true';
    if (discount > 0 && price > 0 && !ready) return null;
    return { variantId: selected.value, title: card.dataset.label + (selected.textContent.trim() === 'Default Title' ? '' : ' — ' + selected.textContent.trim()), offer: (free ? 'free_' : 'upgrade_') + card.dataset.slot, parentTitle: this.dataset.productTitle, expectedPrice: Math.round(price * (100 - discount) / 100) };
  }
  update() {
    const checked = this.querySelector('input[type="radio"]:checked');
    this.querySelectorAll('[data-slot]').forEach(card => {
      const select = card.querySelector('select');
      const variants = card.querySelector('.gic-chain__variants');
      const active = card.querySelector('input[type="radio"]') === checked;
      if (variants) variants.hidden = !active || select.options.length < 2;
      const selected = select?.selectedOptions[0];
      if (!selected || card.dataset.free === 'true') return;
      const price = Number(selected.dataset.price) || 0;
      const compare = Math.max(Number(selected.dataset.compare) || price, price);
      const effective = Math.round(price * (100 - (Number(card.dataset.discount) || 0)) / 100);
      const priceNode = card.querySelector('[data-price]');
      if (priceNode) priceNode.textContent = '+ ' + this.money(effective);
      const compareNode = card.querySelector('[data-compare]');
      if (compareNode) { compareNode.textContent = this.money(compare); compareNode.hidden = compare <= effective; }
    });
    const choice = this.getSelection();
    const summary = this.querySelector('[data-chain-summary]');
    const complete = this.isSelectionComplete();
    const selectionText = choice ? choice.title + (choice.expectedPrice === 0 ? ' — FREE with your pendant.' : ' — + ' + this.money(choice.expectedPrice) + ' per pendant.') : complete ? 'No extra chain — pendant only.' : 'Select a chain option';
    if (summary) summary.textContent = complete ? selectionText : 'Select a chain option above, or choose No extra chain.';
    const toggleSelection = this.querySelector('[data-chain-toggle-selection]');
    if (toggleSelection) toggleSelection.textContent = selectionText;
    if (complete) this.clearError();
    const form = this.closest('product-form-component');
    if (form) {
      form.dataset.gicChainSelected = choice ? 'true' : 'false';
      form.dataset.gicChainChoiceComplete = complete ? 'true' : 'false';
      const accelerated = form.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (accelerated) {
        if (choice || !complete) { if (!accelerated.hasAttribute('data-gic-original-hidden')) accelerated.dataset.gicOriginalHidden = accelerated.hidden ? 'true' : 'false'; accelerated.hidden = true; }
        else if (accelerated.hasAttribute('data-gic-original-hidden')) { accelerated.hidden = accelerated.dataset.gicOriginalHidden === 'true'; delete accelerated.dataset.gicOriginalHidden; }
      }
    }
  }
}
if (!customElements.get('gic-pendant-chain-picker')) customElements.define('gic-pendant-chain-picker', GicPendantChainPicker);
  } catch(e) { console.error(e); }
})();

})();
